if (!customElements.get('cart-add-more')) {
  customElements.define(
    'cart-add-more',
    class CartAddMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.button.addEventListener('click', () => {
          const cartItems = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
          if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

          const quantity = parseInt(this.dataset.quantity, 10);
          // The theme compares the cart's new quantity with this input afterwards
          // and shows "You can only add N of this item" when they differ, so set
          // it to the quantity being requested first.
          const input =
            document.getElementById(`Quantity-${this.dataset.line}`) ||
            document.getElementById(`Drawer-quantity-${this.dataset.line}`);
          if (input) input.value = quantity;

          this.button.disabled = true;
          this.button.setAttribute('aria-busy', 'true');
          // The theme's own quantity update re-renders the drawer and free shipping bar.
          cartItems.updateQuantity(this.dataset.line, quantity);
        });
      }
    }
  );
}

if (!customElements.get('cart-subscribe-upsell')) {
  customElements.define(
    'cart-subscribe-upsell',
    class CartSubscribeUpsell extends HTMLElement {
      connectedCallback() {
        this.options = [...this.querySelectorAll('[data-plan-id]')];
        this.button = this.querySelector('[data-upsell-submit]');
        this.error = this.querySelector('[data-upsell-error]');
        if (!this.options.length || !this.button) return;

        this.options.forEach((option) => {
          option.addEventListener('click', () => {
            this.options.forEach((other) => other.setAttribute('aria-pressed', String(other === option)));
          });
        });
        this.button.addEventListener('click', this.onSubscribe.bind(this));
      }

      get selectedPlanId() {
        const selected = this.options.find((option) => option.getAttribute('aria-pressed') === 'true') || this.options[0];
        return parseInt(selected.dataset.planId, 10);
      }

      onSubscribe() {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;

        this.setLoading(true);
        if (this.error) this.error.hidden = true;

        const body = JSON.stringify({
          line: parseInt(this.dataset.line, 10),
          quantity: parseInt(this.dataset.quantity, 10),
          selling_plan: this.selectedPlanId,
          sections: drawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((state) => {
            if (state.errors || !state.sections) throw new Error(state.errors || state.description);
            drawer.renderContents(state);
          })
          .catch(() => {
            this.setLoading(false);
            if (this.error) {
              this.error.textContent = (window.cartStrings && window.cartStrings.error) || '';
              this.error.hidden = false;
            }
          });
      }

      setLoading(loading) {
        this.button.disabled = loading;
        this.button.setAttribute('aria-busy', String(loading));
        this.options.forEach((option) => {
          option.disabled = loading;
        });
      }
    }
  );
}

// The drawer has no Remove button: lowering an item's quantity to 0 removes it.
// The theme's quantity-input greys out the minus button at 1 and turns a typed
// "0" back into 1, so both are allowed inside the cart drawer only.
(function () {
  const QuantityInput = customElements.get('quantity-input');
  if (!QuantityInput || QuantityInput.prototype.allowsZeroInCartDrawer) return;

  const allowsZero = (quantityInput) =>
    quantityInput.input && quantityInput.input.min === '0' && quantityInput.closest('cart-drawer');

  const setMinimumDisable = QuantityInput.prototype.setMinimumDisable;
  QuantityInput.prototype.allowsZeroInCartDrawer = true;
  QuantityInput.prototype.setMinimumDisable = function () {
    if (!allowsZero(this)) return setMinimumDisable.call(this);
    const minus = this.querySelector('button[name="minus"]');
    if (minus) minus.classList.remove('disabled');
  };

  // Items already in the drawer were set up before this file loaded.
  document.querySelectorAll('cart-drawer quantity-input').forEach((quantityInput) => {
    quantityInput.setMinimumDisable();
  });

  // Runs before the theme's own input handler, which would reset 0 to 1.
  document.addEventListener(
    'input',
    (event) => {
      const input = event.target;
      if (!input.classList || !input.classList.contains('quantity__input')) return;
      if (!input.closest('cart-drawer') || !/^0+$/.test(input.value)) return;
      event.stopPropagation();
    },
    true
  );
})();
